function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { UrlIcon } from "@thebouqs/icon";
import React, { useMemo } from "react";
import { __TARGET_ENV_PROD__ } from "@thebouqs/utils";
import { getBouqsIconProps } from "./url-icons.utils";
export function BouqsCdnIcon(props) {
  var {
    icon,
    isProduction = __TARGET_ENV_PROD__
  } = props,
      moreProps = _objectWithoutPropertiesLoose(props, ["icon", "isProduction"]);

  var {
    url,
    alt
  } = useMemo(() => getBouqsIconProps(icon, {
    isProduction
  }), [icon, isProduction]);
  return /*#__PURE__*/React.createElement(UrlIcon, _extends({}, moreProps, {
    url: url,
    alt: alt
  }));
}
//# sourceMappingURL=bouqs-cdn-icon.js.map